let headerHeightQuestions = $('.c-site-header').height() + 100 ;

$(window).on('resize', function () {
    headerHeightQuestions = $('.c-site-header').height() + 100 ;
});

if ($('.c-faqs-questions').length) {
    $('.c-faqs-questions').attr('id', 'js-faqs-questions')
}

$('.c-faqs-questions__link').on('click',function(event){
    //event.preventDefault();
    $(this).addClass('is-active');
    var target = $($(this).attr('href'));
    $('html,body').animate({ 
        scrollTop: target.offset().top - headerHeightQuestions
    },1400)
});

